module.exports = __webpack_public_path__ + "media/images/people/boy-6-e6b9548d9a6cdd3e9c3be675609c9c62.webp";